module.exports = __webpack_public_path__ + "static/media/Backdrop.d48bcda4.png";